<script setup lang="ts">
import AgTableServer from '@/modules/common/components/ag-table/AgTableServer.vue';
import { venueService } from '@/connect/services/venue';
import * as cols from '@/modules/common/components/ag-table/columns/venue';
import { useSocketStore } from '@/store/socket-store';
import { LoadSuccessParams } from 'ag-grid-enterprise';
import i18n from '@/localisation/i18n';
import { useSnackbarManager } from '@/modules/snackbar/services/snackbar-manager';
import { shallowRef } from 'vue';

const snackbarManager = useSnackbarManager();
const socketStore = useSocketStore();

const props = defineProps<{ parentId: string }>();

const columnDefs = [
  cols.status(),
  cols.orderIntent(),
  cols.side(),
  cols.ticker(),
  cols.openQuantity(),
  cols.totalQuantity(),
  cols.execQuantity(),
  cols.fee(),
  cols.rebate(),
  cols.minQuantity(),
  cols.agreements(),
];

const refresh = shallowRef(() => {
  return;
});

socketStore.useEventHandler('refreshVenueOrders', () => refresh.value());

async function queryData(): Promise<LoadSuccessParams | undefined> {
  const result = await venueService.listChildOrders(props.parentId);

  if (!result.success) {
    snackbarManager.show({ message: i18n.t(result.error, result.details) as string });
    return;
  }
  const orders = result.data.orders;
  orders.sort(
    (a, b) => new Date(b.updatedAt).getTime() || 0 - new Date(a.updatedAt).getTime() || 0
  );

  return { rowData: orders, rowCount: orders.length };
}
</script>

<template>
  <AgTableServer
    :column-defs="columnDefs"
    :get-row-id="(order) => order.clientOrderRef"
    no-menu
    no-move
    no-sort
    :page="1"
    :page-size="Infinity"
    :query-data="queryData"
    :sort="{ colId: 'updatedAt', sort: 'desc' }"
    @ready="(config) => (refresh = config.refresh)"
  />
</template>

<style lang="scss"></style>
